import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap"
import { hexaToRgba } from "../../../components/functions"
import Heading from "../../../components/paragraph/heading"
import Paragraph from "../../../components/paragraph/paragraphs"

export default props => {
  let header = props.data.data.relationships
  let image = header.field_image.relationships.field_media_image.localFile
  let caption = header.field_caption

  return (
    <Container
      className={"c_PageHeader dark"}
      fluid={true}
      style={{
        height: "calc(100vh - 110px)",
        maxHeight: "360px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <GatsbyImage
        image={image.childImageSharp.gatsbyImageData}
        style={{
          position: "absolute",
          minWidth: "100%",
          minHeight: "100%",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }} />

      {props.data.data.field_background_color && (
        <div
          style={{
            backgroundColor: hexaToRgba(props.data.data.field_background_color),
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        />
      )}

      <Row>
        <Container
          style={{
            position: "absolute",
            bottom: "40px",
            left: "50%",
            transform: "translate(-50%)",
          }}
        >
          <Row className={"justify-content-start"}>
            <Col xs={12} md={8} xl={6}>
              {caption.map((caption, key) => {
                let type
                try {
                  type = caption.internal.type
                } catch (e) {}
                switch (type) {
                  case "paragraph__component_heading":
                    return (
                      <Heading
                        props={caption}
                        type={caption.field_heading_type}
                        key={key}
                      />
                    )
                  case "paragraph__component_paragraph_s":
                    return <Paragraph props={caption} key={key} />
                  default:
                    return (
                      <p
                        key={key}
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          background: "white",
                        }}
                      >
                        Failed to load component!
                      </p>
                    )
                }
              })}
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  );
}
